module.exports = __webpack_public_path__ + "static/media/upload_file.9521f103.svg";